import { Observable } from 'rxjs';

export interface NgxCmAuthProvider {
    Logout(): Observable<any>;
    Login(): Observable<any>;
    GetAuthorizationHeader(): Headers;
    RefreshToken(): Observable<any>;
}